import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { stickycard } from "./parts/stickycard";
import { scrollSlider } from "./parts/stickyslider";
import { cursorChange } from "./parts/cursor";
import { nove } from "./parts/nove";
import { fnc_fav_init } from "./parts/fav";
import { smoothmove, smoothPause, lenis   } from "./parts/lenis";
import Splide from '@splidejs/splide';
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'slick-carousel';
require('jquery-zoom');

gsap.registerPlugin(ScrollTrigger);

const init = async () => {
    console.log('everytime page load');
	//smoothercreate();
    //smoothloc();
	scrollSlider();
    stickycard();
	menuFunction();
    navHover();
	menuActive();
	homeSlider();
    fullCarousel();
	bottomSlider();
	viewportMode();
	smoothmove();
	videoScrub();
	cursorChange();
	scrollVisible();
	playVideo();
	collectionFilter();
	search();
	modalsView();
	modalViewImage();
	modalViewVideo();
	modalProductCard();
	modalProductCardAutoOpen();
	fadeOutLoader();
	pageSlider();
	footerSlider();
	nove();
	companyScroll();
	animationTxtStart();
	animationTxt();
	videoControl();
	deviceVideo('#home-video');
	modalDownload();
	downloadButton();
	closeMenuonSameLink();
	lazyBlocks();
	collection_filters_preload();
	fnc_fav_init();
};

export { init };

let body = document.querySelector('body');

function downloadButton() {
	jQuery("a[download]:not(.no-delay)").on("click", function () {
		let this_o = jQuery(this);
		let this_o_text = jQuery(this_o).html();

		jQuery(this_o).addClass("disable-pointer");
		jQuery(this_o).html(ThisThemeAJAX.downloading);

		let this_timeout = setTimeout(function () {
			jQuery(this_o).removeClass("disable-pointer");
			jQuery(this_o).html( this_o_text );
		}, ThisThemeAJAX.downloading_delay); // will work with every browser
	});
}

function menuActive() {
	var aTag = jQuery(".menubox li a");
	aTag.each(function() {
		if (this.href == window.location.href) {
			jQuery(this).closest('li').addClass("active");
			var mediaID = jQuery(this).closest('li').data("media");
			var mediaClass = '.media-'+mediaID;
    		jQuery(mediaClass).addClass('active-always');
		}
	});
}

function navHover() {
	var nav = jQuery(".menubox li");
	nav.on("mouseenter", function () {
		var mediaID = jQuery(this).data("media");
		var mediaClass = '.media-'+mediaID;
		jQuery(mediaClass).addClass('active');
		if(jQuery(mediaClass).hasClass('video')) {
		jQuery(mediaClass + ' video').get(0).play();
		}
	});
	nav.on("mouseleave", function () {
		jQuery('.menuhover-box ul li').removeClass("active");
		if(jQuery('.menuhover-box ul li video').length) {
			jQuery('.menuhover-box ul li video').get(0).pause();
		}
	} );
}

function fullCarousel() {
	var $targetElement = jQuery('.carousel-js');
	if(jQuery($targetElement).length!=0 && jQuery('.carousel-js.slick-initialized').length==0) {
		jQuery($targetElement).slick({
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 5,
			touchThreshold:10,
			draggable:true,
			swipeToSlide: true,
			autoplay: false,
			arrows: false,
			rows: 0,
			responsive: [{
				breakpoint: 1500,
				settings: {
				  slidesToShow: 4,
				}
			  },{
				breakpoint: 1000,
				settings: {
				  slidesToShow:3,
				}
			  },{
				breakpoint: 760,
				settings: {
				  slidesToShow:2,
				}
			  },{
				breakpoint: 430,
				settings: {
				  slidesToShow:1,
				}
			  }]
		});
	}
	// add class when mouse is pressed
	$targetElement.on('mousedown', function() {
		$targetElement.addClass('mouse-down');
	});
	// remove class when mouse is released
	$targetElement.on('mouseup', function() {
		$targetElement.removeClass('mouse-down');
	});
	// on click 'move-car-left' move carousel to the left
	jQuery('.move-car-left').on('click', function() {
		$targetElement.slick('slickPrev');
	});
	// on click 'move-car-right' move carousel to the right
	jQuery('.move-car-right').on('click', function() {
		$targetElement.slick('slickNext');
	});
}

function bottomSlider() {
	var $targetElement = jQuery('.bottomslider-js');
	if(jQuery($targetElement).length!=0 && jQuery('.bottomslider-js.slick-initialized').length==0) {
		jQuery($targetElement).slick({
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 2,
			touchThreshold:10,
			draggable:true,
			swipeToSlide: true,
			variableWidth:true,
			autoplay: true,
			arrows: false,
			rows: 0,
			responsive: [{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			}]
		});
	}
	// add class when mouse is pressed
	$targetElement.mousedown(function() {
		$targetElement.addClass('mouse-down');
	});
	// remove class when mouse is released
	$targetElement.mouseup(function() {
		$targetElement.removeClass('mouse-down');
	});
	// on click 'move-car-left' move carousel to the left
	jQuery('.move-car-left').click(function() {
		$targetElement.slick('slickPrev');
	});
	// on click 'move-car-right' move carousel to the right
	jQuery('.move-car-right').click(function() {
		$targetElement.slick('slickNext');
	});
}

function homeSlider() {
	var $targetElement = jQuery('.homeslider-js');
	if(jQuery($targetElement).length!=0 && jQuery('.homeslider-js.slick-initialized').length==0) {

		jQuery('.homeslider-js').on('init', function(event, slick){
			jQuery('.slick-current').addClass('txt-animate');
		});

		jQuery($targetElement).slick({
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			touchThreshold:10,
			draggable:true,
			swipeToSlide: true,
			autoplay: true,
			arrows: false,
			rows: 0,
		});
	}
	jQuery('.homeslider-js').on('beforeChange', function(event){
		jQuery('.slick-current').removeClass('txt-animate');
	});

	jQuery('.homeslider-js').on('afterChange', function(event){
		jQuery('.slick-current').addClass('txt-animate');
	});

	jQuery('.move-slide-left').click(function() {
		$targetElement.slick('slickPrev');
	});
	// on click 'move-car-right' move carousel to the right
	jQuery('.move-slide-right').click(function() {
		$targetElement.slick('slickNext');
	});
}

function playVideo() {
	//play video on click
	jQuery('.play-video').click(function() {
		var video = jQuery(this).closest('.feature-video').find('video').get(0);
		var cursorElement = jQuery("#cursor");
		if(jQuery(this).hasClass('hide')) {
			var data = jQuery(this).closest('.feature-video').data('newcursor');
			jQuery(cursorElement).find("span").text(data);
			video.pause();
			jQuery(this).removeClass('hide');
		} else {
			var data = jQuery(this).data('videopause');
			jQuery(cursorElement).find("span").text(data);
			video.play();
			jQuery(this).addClass('hide');
		}
	});
}

function collectionFilter() {

	jQuery('.coll-filter-text').on('click', function() {
		jQuery('.collection-filter-opened').slideDown( 500, function() {
			jQuery(".collection-filter").addClass("opened");
		} );
	});
	//coll-close
	jQuery('.coll-close').on('click', function() {
		jQuery('.collection-filter-opened').slideUp( 500, function() {
			jQuery(".collection-filter").removeClass("opened");
		});
	});

	jQuery(".collection-filters").each( function() {
		let this_o = jQuery(this);

		jQuery(this_o).find('.collection-filters__button').on('click', function(e) {
			e.preventDefault();
			jQuery(this_o).toggleClass("opened").find(".collection-filters__filters").slideToggle(1000);
			return false;
		});
	});
}

function search() {
	jQuery('.search-open').on('click', function() {
		jQuery('.main-search-model').addClass('opened');
		jQuery('.main-search-model').slideDown();
		smoothPause(true);
	});
	//coll-close
	jQuery('.search-close').on('click', function() {
		jQuery('.main-search-model').removeClass('opened');
		jQuery('.main-search-model').slideUp();
		smoothPause(false);
	});
}

function modalProductCard() {

	let clickScrollY = 0;

	jQuery(".product-slick").each(function () {

		jQuery(this).slick({
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			touchThreshold: 10,
			draggable: true,
			swipeToSlide: true,
			autoplay: true,
			arrows: false,
			pagination: true,
			rows: 0,
		});
	});

	jQuery("body").on("click", "[modal-open-id]", function (e) {
		e.preventDefault();
		let data = jQuery(this).attr("modal-open-id");
		if ( data !== '' ) {
			jQuery(data + ".modal-container").each( function() {
				let this_o = jQuery(data + ".modal-container");
				jQuery(this_o).addClass("opened");
				jQuery(this_o).slideDown();

				smoothPause(true);

				jQuery(this_o).find(".splide").each(function () {
					if ( ! jQuery(this).hasClass('is-initialized') ) {
						const this_splide = new Splide( jQuery(this)[0], {
							type   : 'loop',
							perPage: 1,
							arrows: false,
							pagination: true,
							autoplay: false,
							interval: 2000,
						} );

						this_splide.mount();
					}
				});

				if (window.innerWidth > 768) {
					jQuery(this_o).find("[data-zoomimage]").each( function() {
						jQuery(this).zoom({ url: jQuery(this).attr('data-zoomimage') });
					});
				}

				jQuery(this_o).find(".link-share").each( function() {
					jQuery(this).on('click', function(e) {
						e.preventDefault();
						var aux = document.createElement("input");
							aux.setAttribute("value", jQuery(this).attr('href'));
							document.body.appendChild(aux);
							aux.select();
							document.execCommand("copy");
							document.body.removeChild(aux);
						return false;
					});
				});
			});
		}
		return false;
	});

	jQuery(document).on('click', '.modal-close', function(e) {
		e.preventDefault();
		jQuery(this).closest(".modal-container").removeClass("opened");
		jQuery(this).closest(".modal-container").slideUp();

		smoothPause(false);

		return false;
	});

}

function modalProductCardAutoOpen() {

	if ( window.location.hash ) {
		const hash = window.location.hash.substring(1);
		const prefix = "modalProductCardOpen";
		if ( hash.startsWith( prefix ) ) {
			const id = hash.substring( prefix.length );
			const modal = document.querySelectorAll('[modal-open-id="#modalProductCard' + id + '"]');
			modal.forEach(function (element) {
				element.click();
				history.pushState("", document.title, window.location.pathname + window.location.search);
			});
		}
	}

}

function fadeOutLoader() {
	const loader = jQuery('.loader');

	return new Promise((resolve) => {
		gsap.to(loader, {
			duration: 1.5,
			autoAlpha: 0,
			onComplete: resolve
		});
	});
}

function pageSlider() {
	var $targetElement = jQuery('.pageslider-js');
	if(jQuery($targetElement).length!=0 && jQuery('.pageslider-js.slick-initialized').length==0) {
		jQuery($targetElement).slick({
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			touchThreshold:10,
			draggable:true,
			swipeToSlide: true,
			autoplay: true,
			arrows: false,
			rows: 0,
		});
	}
}

function footerSlider() {
	var $targetElement = jQuery('.footer-xtra-text-slider');
	if(jQuery($targetElement).length!=0 && jQuery('.footer-xtra-text-slider.slick-initialized').length==0) {
		jQuery($targetElement).slick({
			fade: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			touchThreshold:10,
			draggable:true,
			swipeToSlide: true,
			autoplay: true,
			arrows: false,
			pauseOnHover: false,
			rows: 0,
		});
	}
}

export function collection_filters_call(filters, this_obj) {

	jQuery(this_obj).closest(".collection-filters").addClass("thinking");

	jQuery.ajax({
		url: ThisThemeAJAX.admin_ajax,
		type: "post",
		dataType: "json",
		data: {
			action: "_collection_filters_call",
			filters: filters,
			lang: ThisThemeAJAX.lang
		},

		success: function (response) {
			if ("" !== response.data.result) {
				jQuery(this_obj).closest(".collection-filters").find(".category-list-box-results > a").fadeOut(400, function () {
					jQuery(this).html(response.data.result).fadeIn(400);
				});
      		}

			jQuery(".collection-filter-loop").fadeOut(400, function () {
				jQuery(this).html(response.data.html).fadeIn(400);
				fnc_fav_init();
			});
		},

		error: function (response) {
			console.log("Error en la petición");
		},

		complete: function( jqXHR, textStatus ) {
			jQuery(this_obj).closest(".collection-filters").removeClass("thinking");
		}
	});
}



function collection_filters_preload() {
  jQuery(".collection-filter-loop.collection-filter-loop-preload").each(
    function () {
      jQuery.ajax({
        url: ThisThemeAJAX.admin_ajax,
        type: "post",
        dataType: "json",
        data: {
          action: "_collection_filters_call",
          filters: false,
          lang: ThisThemeAJAX.lang,
        },

        success: function (response) {
          if ("" !== response.data.result) {
            jQuery(".collection-filter-loop").fadeOut(400, function () {
              jQuery(this).html(response.data.html).fadeIn(400);
              fnc_fav_init();
            });
          }
        },

        error: function (response) {
          console.log("Error en la petición");
        },
      });

	  jQuery(this).removeClass("loader-container;");
	  jQuery(this).removeClass("collection-filter-loop-preload");
    }
  );
}

function videoControl() {
	//hide intp-content after 2 sec
	setTimeout(function(){
		jQuery('.video-into-content').addClass('hidecontent');
	}, 6000);
	//play
	var playPauseBtn = document.querySelectorAll('.playbutton');
	playPauseBtn.forEach( function(playPause) {
		var videoTag = playPause.dataset.video;
		playPause.addEventListener('click', function() {
			var videoEl = document.querySelector( videoTag );
			if ( jQuery(this).hasClass("paused") ) {
				jQuery(this).removeClass("paused");
				jQuery('.video-into-content').removeClass("hidecontent");
				videoEl.pause();
			} else {
				jQuery(this).addClass("paused");
				jQuery('.video-into-content').addClass("hidecontent");
				videoEl.play();
			}
		});
	});

	//mute
	var muteIcons = document.querySelectorAll('.muteicon');
	muteIcons.forEach( function(muteIcon) {
		var videoTag = muteIcon.dataset.video;
		muteIcon.addEventListener('click', function() {
			var videoEl = document.querySelector( videoTag );
			videoEl.muted = !videoEl.muted;
			muteIcon.classList.toggle('mute');
		});
	});
}

function deviceVideo(element) {
	var videoElement = jQuery(element);
	if(videoElement.length == 0) return;
	var video = videoElement.find('source');
	let mobileVideoSrc = videoElement.data('mobilesrc');
	let desktopVideoSrc = videoElement.data('desktopsrc');
	if (window.innerWidth < 768) {
		video.attr('src', mobileVideoSrc);
	} else {
		video.attr('src', desktopVideoSrc);
	}
	videoElement[0].load();
}

function modalViewImage() {
	jQuery("body").on("click", "a[data-viewimage]", function (e) {
		e.preventDefault();

		const image_url = jQuery(this).attr("data-viewimage");

		jQuery("#modalViewImage").each( function () {
			jQuery(this).addClass("opened");
			jQuery(this).slideDown();
			smoothPause(true);

			jQuery(this).find(".view-image-content").css('background-image', 'url(' + image_url + ')');

			jQuery(this).on("click", ".modal-close", function (e) {
				e.preventDefault();

				jQuery(this).closest(".modal-container").removeClass("opened");
				jQuery(this).closest(".modal-container").slideUp();
				smoothPause(false);

				jQuery(this).find(".view-image-content").css('background-image', 'url()');

				return false;
			});
		});

		return false;
	});
}

function modalViewVideo() {
	jQuery("body").on("click", "a[data-viewvideo]", function (e) {
		e.preventDefault();

		const video_code = jQuery(this).attr("data-viewvideo");

		jQuery("#modalViewVideo:not(.opened)").each( function () {
			jQuery(this).addClass("opened");
			jQuery(this).slideDown();
			smoothPause(true);

			jQuery(this).find(".view-video-content").append(video_code);

			jQuery(this).find(".modal-close").on("click", function (e) {
				e.preventDefault();

				jQuery(this).closest(".modal-container").find(".view-video-content").empty();

				jQuery(this).closest(".modal-container").removeClass("opened");
				jQuery(this).closest(".modal-container").slideUp();
				smoothPause(false);

				return false;
			});
		});

		return false;
	});
}

function modalsView() {
	jQuery("body").on("click", "a[data-viewmodal]", function (e) {
		e.preventDefault();

		const viewmodal = jQuery(this).attr("data-viewmodal");

		jQuery(viewmodal).each(function () {
			jQuery(this).addClass("opened");
			jQuery(this).slideDown();
			smoothPause(true);

			jQuery(this).on("click", ".modal-close", function (e) {
				e.preventDefault();

				jQuery(this).closest(".modal-container").removeClass("opened");
				jQuery(this).closest(".modal-container").slideUp();
				smoothPause(false);

				return false;
			});
		});

		return false;
	});
}

var modalDownload_Link = false;
function modalDownload() {

	jQuery('a[data-dwnurl]').on('click', function(e) {
		e.preventDefault();

		modalDownload_Link = this;

		if ( false === modalDownload__active( modalDownload_Link ) ) {

			jQuery("#modalDownloadForm").each( function () {
				jQuery(this).addClass("opened");
				jQuery(this).slideDown();
				smoothPause(true);

				jQuery(this).on("click", ".modal-close", function (e) {
					e.preventDefault();

					jQuery(this).closest(".modal-container").removeClass("opened");
					jQuery(this).closest(".modal-container").slideUp();
					smoothPause(false);

					return false;
				});

				return false;
			});

		}

		return false;
	});

}

function modalDownload__active( this_o ) {
	if ( false !== modalDownload_Link && true === modalDownload__cookie_status() ) {
		window.location = jQuery(modalDownload_Link).attr("data-dwnurl");
		modalDownload_Link = false;
		jQuery("#modalDownloadForm").each( function () {
			jQuery(this).closest(".modal-container").removeClass("opened");
			jQuery(this).closest(".modal-container").slideUp();
		} );
		smoothPause(false);

		let this_o_text = jQuery(this_o).html();

		jQuery(this_o).addClass("disable-pointer");
		jQuery(this_o).html(ThisThemeAJAX.downloading);

		let this_timeout = setTimeout(function () {
			jQuery(this_o).removeClass("disable-pointer");
			jQuery(this_o).html(this_o_text);
		}, ThisThemeAJAX.downloading_delay); // will work with every browser

		return true;
	}

	return false;
}

function modalDownload__cookie_status() {
	var descargas_tpl_cookie = tt__getCookie("modalDownload_cookie");
	return descargas_tpl_cookie === "" ? false : true;
}


/* Funciones para gestion de cookies */
function tt__setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function tt__getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function tt__checkCookie(cname) {
	var user = tt__getCookie(cname);
	if (user != "") {
		return true;
	}

	return false;
}

function closeMenuonSameLink() {
	jQuery('.menubox li a').on('click', function() {
		menuClose();
	});
}


function lazyBlocks() {
	jQuery('[data-lazyblock]').each( function() {
		let this_obj = jQuery(this);
		let block = jQuery(this_obj).attr('data-lazyblock');

		jQuery(this_obj).addClass("thinking");

		if ( block !== '' ) {

			let block_a = block.split(",");

			jQuery.ajax({
				url: ThisThemeAJAX.admin_ajax,
				type: "post",
				dataType: "json",
				data: {
					action: "_lazy_block",
					first: block_a[0],
					second: block_a[1],
					lang: ThisThemeAJAX.lang
				},

				success: function (response) {
					jQuery(this_obj).fadeOut(400, function () {
						jQuery(this_obj).html(response.data.html).fadeIn(400);
					});
				},

				error: function (response) {
					console.log("Error en la petición");
				},

				complete: function( jqXHR, textStatus ) {
					jQuery(this_obj).delay(500).removeClass("thinking");
				}
			});
		}

	} );
}





function menuFunction() {
  //on click open menu
  var menu = jQuery(".nav-menu-icon");
  menu.on("click", function () {
    if (menu.hasClass("active")) {
      menuClose();
    } else {
      menuOpen();
    }
  });
}

function menuOpen() {
  var menuSection = document.querySelector(".menu-section");
  //smoothPause(true);
	smoothPause(true);
  let tl = gsap.timeline();
    tl.addLabel("menustart");
    tl.fromTo(
        menuSection,
        {
          scale: 1.5,
          x: "-100%",
        },
        {
          duration: 0.5,
          scale: 1,
          x: 0,
        },
        "menustart"
      )
      .add(function () {
        setClass(true);
      });
}

function menuClose() {
  var menuSection = document.querySelector(".menu-section");

  let tl = gsap.timeline();
  tl.addLabel("menuclose");
  tl.to(menuSection, {
    duration: 0.5,
    x: "-101%",
    scale: 1,
  })

    .add(function () {
      setClass(false);
    });
	smoothPause(false);
}

function setClass(addactive) {
  if (addactive) {
    jQuery(".nav-menu-icon").addClass("active");
    jQuery("body").removeClass("short-header");
  } else {
    jQuery(".nav-menu-icon").removeClass("active");
    jQuery("body").removeClass("menuactive");
  }
}

function viewportMode() {
  var modeElements = jQuery("[data-mode]");
  //foreach mode change class from dark or light
  modeElements.each(function (index, element) {
    var mode = jQuery(element).data("mode");
    let tl = gsap.timeline({
      scrollTrigger: {
        //markers: true,
        trigger: element,
        start: "top 50%",
        end: "bottom 50%",
        scrub: 1,
        onEnter: function () {
          addModeClass(mode, 'top');
        },
        onEnterBack: function () {
          addModeClass(mode, 'top');
        },
      },
    });

    var bottommode = mode + "-bottom";
    let bt = gsap.timeline({
      scrollTrigger: {
        //markers: true,
        trigger: element,
        start: "top 97%",
        end: "bottom 98%",
        scrub: 1,
        onEnter: function () {
          addModeClass(bottommode, 'bottom' );
        },
        onEnterBack: function () {
          addModeClass(bottommode, 'bottom');
        },
      },
    });
  });
}

let viewportModeTimeout;
const resizeObserver = new ResizeObserver((entries) => {
  clearTimeout(viewportModeTimeout);
  viewportModeTimeout = setTimeout(viewportMode, 1100);
});
// start observing a DOM node
resizeObserver.observe(document.body);


function addModeClass(mode, pos) {
  if(pos == 'top') {
  body.classList.remove("dark");
  body.classList.remove("light");
  } else {
    body.classList.remove("dark-bottom");
    body.classList.remove("light-bottom");
  }
  body.classList.add(mode);
}

function videoScroll() {
  var videoEle = jQuery("#home-middle-video");
  if (videoEle == undefined || videoEle == null || videoEle.length == 0) {
    return;
  }
  var videoReset = jQuery(".video-reset");
  let reset = gsap.timeline({
    scrollTrigger: {
      //markers: true,
      trigger: videoReset,
      start: "50% 100%",
      scrub: 1,
      onEnter: function () {
        videoEle.get(0).currentTime = 0;
      },
    },
  });

  var videoWrap = jQuery(".video-box");
  let tl = gsap.timeline({
    scrollTrigger: {
      markers: false,
      trigger: videoWrap,
      pin: true,
      start: "top top",
      scrub: 1,
      pinSpacing: true,
    },
  });
}

function videoScrub() {
  var labels = jQuery(".label-container");
  var videoEle = jQuery("#home-middle-video");
  if (videoEle == undefined || videoEle == null || videoEle.length == 0) {
    return;
  }
  jQuery.each(labels, function (index, element) {
    var label = jQuery(element);
    var start = label.data("start");
    var end = label.data("end");
    var button = label.find(".button-label");
    button.on("click", function () {
      if (!label.hasClass("active")) {
        videoShow(start, end, label);
      }
    });
    // let tl = gsap.timeline({
    //   scrollTrigger: {
    //    // markers: true,
    //     trigger: label,
    //     start: "top 20%",
    //     end: "bottom 21%",
    //     onEnter: function () {
    //       //console.log('on enter call');
    //       if (!label.hasClass('active')) {
    //         videoShow(start, end, label);
    //       }
    //     }
    //     //scrub: 1,
    //   },
    // });
  });
}

function videoShow(start, end, label) {
  var videoEle = jQuery("#home-middle-video");
  if (videoEle == undefined || videoEle == null || videoEle.length == 0) {
    return;
  }
  //console.log('videoShow');
  jQuery(".label-container").removeClass("active");
  jQuery(".label-container").removeClass("videopause");
  jQuery(".videolabel-holder").removeClass("active");
  jQuery(".videolabel-holder").text("");

  jQuery(".video-label-collections").addClass("active");
  label.addClass("active");

  var video = videoEle.get(0);
  //console.log(video.currentTime, start, end);
  function checkTime() {
    if (video.currentTime >= end) {
      video.pause();
      var text = jQuery(label).find(".videolabel").text();
      jQuery(".videolabel-holder").text(text);
      jQuery(label).addClass("videopause");
      jQuery(".videolabel-holder").addClass("active");
      jQuery(".video-label-collections").removeClass("active");
      //smoothPause(false);
    } else {
      setTimeout(checkTime, 10);
    }
  }
  video.currentTime = start;
  //video.play();
  playvideo(video);
  //smoothPause(true);
  checkTime();
}

function playvideo(video) {
  var isPlaying =
    video.currentTime > 0 &&
    !video.paused &&
    !video.ended &&
    video.readyState > video.HAVE_CURRENT_DATA;
  if (!isPlaying) {
    video.play();
  }
}

function scrollVisible() {
  if (jQuery(".blog-post").length == 0) {
    return;
  }
  ScrollTrigger.batch(".blog-post", {
    //markers: true,
    start: "top 80%",
    toggleClass: "visible",
  });
}

function companyScroll() {
  var sectionBg = jQuery(".stickysectionbg");
  if (sectionBg == undefined || sectionBg == null || sectionBg.length == 0) {
    return;
  }

  let cs = gsap.timeline({
    scrollTrigger: {
      //markers: true,
      trigger: sectionBg,
      pin: true,
      start: "top top",
      endTrigger: '.block-scrolling_text-section',
      end: "bottom bottom",
      scrub: 1,
      pinSpacing: true,
    },
  });

  ScrollTrigger.batch('.company-scroll', {
    //markers: true,
    start: "top 50%",
    end: "bottom 50%",
    toggleClass: "active",
    onUpdate: batch => {
      changeBg(batch);
    },
  });
}

function changeBg(element) {
  if (jQuery(element).hasClass('active')) {
          jQuery('.company-scroll-img').removeClass("active");
          var mediaID = jQuery(element).data("slider");
          jQuery(mediaID).addClass("active");
        }
}

function animationTxt() {
  ScrollTrigger.batch(".txt-animation", {
    //markers: true,
    start: "top 80%",
    onEnter: batch => {
      jQuery(batch).addClass("txt-animate");
    },
  });
}

function animationTxtStart() {
  if (jQuery('.txt-animation-start').length != 0) {
    jQuery('.txt-animation-start').addClass("txt-animate");
  }
  if (jQuery('.txt-animation-start-delay').length != 0) {
    jQuery('.txt-animation-start-delay').addClass("txt-animate");
  }
  if (jQuery('.txt-animation-start-delay-2').length != 0) {
    jQuery('.txt-animation-start-delay-2').addClass("txt-animate");
  }
  if (jQuery('.zoom-animation-start').length != 0) {
    jQuery('.zoom-animation-start').addClass("zoom-animate");
  }
}
